import {
    getPaymentClientLoading,
    getPaymentClientReject,
    getPaymentClientRequest,
    getPaymentClientSuccess
} from "../../actions/paymentClients/getAll";

export const getPaymentClient = (formData) => async (dispatch, getState) => {
    dispatch(getPaymentClientLoading());
    try {
        const { data } = await getPaymentClientRequest(formData, getState);
        dispatch(getPaymentClientSuccess(data))
    } catch (error) {
        dispatch(getPaymentClientReject(error))
    }
    return Promise.resolve();
};